module.exports = __webpack_public_path__ + "assets/img/chat.284bfe19.svg";